import React from "react"
import "./SimpleIndustries.css"

const SimpleIndustries = ({
  gridSize,
  feature,
  backgroundimage,
  title,
  subtitle,
}) => {
  console.log(
    "girdsize, features, background",
    gridSize,
    feature,
    backgroundimage
  )

  return (
    <div
      className="min-h-screen flex items-center justify-center text-white bg-cover bg-center relative"
      style={{
        backgroundImage: backgroundimage?.mediaItemUrl
          ? `url("${backgroundimage.mediaItemUrl}")`
          : "none",
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      <div className="relative z-10 p-6 md:p-16 rounded-lg w-full">
        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-bold my-4 md:mb-6 text-center text-white">
          {title}
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-gray-300 text-center mx-auto mb-8">
          {subtitle}
        </p>

        {/* Industry Cards */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-${
            gridSize || 3
          } w-full mx-auto gap-4`}
        >
          {feature?.map(
            (item, index) =>
              item.title && (
                <div key={index} className="dynamicFeature-tagAiAgent">
                  <div className="flex flex-col items-start h-full">
                    <div
                      className="w-20 h-20 md:w-24 md:h-24 lg:w-26 lg:h-26 rounded-2xl text-white flex items-center justify-center mb-6 text-2xl md:text-4xl lg:text-6xl"
                      style={{
                        background: "rgba(255, 255, 255, 0.10)",
                      }}
                    >
                      {item.fontello && (
                        <i
                          className={item.fontello}
                          style={{
                            fontSize: "var(--icon-size)",
                            width: "var(--icon-size)",
                            height: "var(--icon-size)",
                          }}
                        />
                      )}
                    </div>
                    <h3 className="text-xl lg:text-2xl font-bold text-white mb-4">
                      {item.title}
                    </h3>
                    <div className="text-left font-normal text-lg text-white overflow-hidden">
                      {item.description}
                    </div>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  )
}

export default SimpleIndustries
